
const SET_FILTER_SORT_SELECTED = "SET-FILTE-SORT-SELECTED";
const SET_FILTER_SORT_SELECTED_URL = "SET-FILTE-SORT-SELECTED-URL";
const TOGGLE_IS_DISPETCHER_SELECT_URL = "TOGGLE-IS-DISPETCHER-SELECT-URL";

let initialState = {
    filterSort: 
        {
            option: [
                { value: 'sort_by=SHOW_COUNTER&sort_dir=desc', label: 'Популярные' },
                { value: 'sort_by=id&sort_dir=desc', label: 'Новинки' },
                { value: 'sort_by=CATALOG_PRICE_1&sort_dir=asc', label: 'Сначала дешёвые' },
                { value: 'sort_by=CATALOG_PRICE_1&sort_dir=desc', label: 'Сначала дорогие' },
                { value: 'sort_by=property_discount&sort_dir=desc', label: 'По размеру скидки' },
                { value: 'sort_by=NAME&sort_dir=asc', label: 'По алфавиту' }
            ]
        },
    valueSelected: "sort_by=SHOW_COUNTER&sort_dir=desc",
    valueSelectedUrl: '',
    isFetchingSelect: false,
}

const filterSortReducer = (state = initialState, action) => {

    switch (action.type) {

        case SET_FILTER_SORT_SELECTED: {

            return {
                ...state,
                filterSort: action.filterSort
            }
        }
        case SET_FILTER_SORT_SELECTED_URL: {

            return {
                ...state,
                valueSelected: action.valueSelected
            }
        }
        case TOGGLE_IS_DISPETCHER_SELECT_URL: {

            return {
                ...state,
                isFetchingSelect: action.isFetchingSelect
            }
        }
        default: {
            return state;
        }
    }

}

export const getValueSelectedUrl = (valueSelected) => {
    
    return {
        type: SET_FILTER_SORT_SELECTED_URL, valueSelected
    }
}
export const settoggleDispetcherSelect = (isFetchingSelect) => {
    return {
        type: TOGGLE_IS_DISPETCHER_SELECT_URL, isFetchingSelect
    }
}
export const getFiltrSelectedAC = (valueSelectedUrl) =>  (dispatch) => {


    dispatch(getValueSelectedUrl(valueSelectedUrl));
    dispatch(settoggleDispetcherSelect(true));

}
export default filterSortReducer;
